//sidebar component
$(document).ready(function () {
    $("html").removeClass("loading"); // reativa a transição

    if (
        $(window).width() >= 1200 &&
        localStorage.getItem("sidebarCollapsed") === "true"
    ) {
        $(".sidebar").addClass("sidebar--collapse");
    }

    $(".btn-event-sidebar").on("click", function () {
        $("html").toggleClass("sidebar--active");
        $(".sidebar").toggleClass("sidebar--collapse");

        if ($(window).width() >= 1200) {
            const isCollapsed = $("html").hasClass("sidebar--active");
            localStorage.setItem(
                "sidebarCollapsed",
                isCollapsed ? "true" : "false"
            );
        }
    });
    $(".event-remove-sidebar").on("click", function () {
        $("html").removeClass("sidebar--active");
        $(".sidebar").removeClass("sidebar--collapse");
    });
});
// sidebar component